<template>
	<div ref="rootRef" :style="placeholderStyle">
		<slot v-if="isVisible" />
	</div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useIntersectionObserver } from "@vueuse/core";

const props = defineProps({
	rootMargin: {
		type: String,
		default: "200px 0px",
	},
	minHeight: {
		type: String,
		default: "",
	},
});

const emit = defineEmits(["visible"]);

const rootRef = ref(null);
const isVisible = ref(false);

const { stop } = useIntersectionObserver(
	rootRef,
	([entry]) => {
		if (entry?.isIntersecting) {
			isVisible.value = true;
			stop();
		}
	},
	{ rootMargin: props.rootMargin }
);

const placeholderStyle = computed(() =>
	!isVisible.value && props.minHeight ? { minHeight: props.minHeight } : undefined
);

watch(isVisible, value => {
	if (value) {
		emit("visible");
	}
});
</script>
